import api from "../../api.js";

export async function fetchStockRequests(mode) {
  const res = await api.get("/api/stock-request", {
    params: mode ? { mode } : undefined,
  });
  return res.data?.data || [];
}

export async function searchStockRequestInventory(type, query, department) {
  const res = await api.get("/api/stock-request/search", {
    params: { type, query, department },
  });
  const data = res.data?.data || null;
  return Array.isArray(data) ? data : data ? [data] : [];
}

export async function createStockRequest(payload) {
  const res = await api.post("/api/stock-request", payload);
  return res.data?.data || null;
}

export async function approveStockRequest(requestId) {
  const res = await api.post(`/api/stock-request/${requestId}/approve`);
  return res.data?.data || null;
}

export async function declineStockRequest(requestId, reason) {
  const res = await api.post(`/api/stock-request/${requestId}/decline`, { reason });
  return res.data?.data || null;
}

export async function fetchBranches() {
  const res = await api.get("/api/branches");
  // branchManagement listBranches returns the array directly
  return res.data || [];
}

export async function fetchStockUsage(sku, branch) {
  if (!sku) throw new Error("sku is required for fetchStockUsage");
  const params = { sku };
  if (branch) params.branch = branch;
  const res = await api.get("/api/stock-usage", { params });
  return Array.isArray(res.data) ? res.data : [];
}

export async function fetchStockAvailability({ sku, name, branch }) {
  const params = {};
  if (sku != null && sku !== "") params.sku = sku;
  if (name != null && name !== "") params.name = name;
  if (branch != null && branch !== "") params.branch = branch;

  const res = await api.get("/api/stock-request/availability", { params });
  return res.data?.data || null;
}

export async function fetchHighestQuantityBranch({ sku, name }) {
  const params = {};
  if (sku != null && sku !== "") params.sku = sku;
  if (name != null && name !== "") params.name = name;

  const res = await api.get("/api/stock-request/highest-quantity", { params });
  return res.data?.data || null;
}
